import React from 'react';
import { Route, Routes } from "react-router-dom";


import Login from './Login/Login'
import StepOne from './ForgetPassword/StepOne';
import StepTwo from './ForgetPassword/StepTwo';
import StepThree from './ForgetPassword/StepThree';


import CheckEmail from './CompanyRegistration/CheckEmail';
import CRStepOne from './CompanyRegistration/StepOne';
import CRStepTwo from './CompanyRegistration/StepTwo';
import CRStepThree from './CompanyRegistration/StepThree';
import CRStepFour from './CompanyRegistration/StepFour';
import CRStepFive from './CompanyRegistration/StepFive';

const LoginScreen = () => {
    return (
        <div className="font-montserrat w-full h-screen">
            <Routes>
                {/* login */}
                <Route path="/" element={<Login />}></Route>


                {/* forget password set up */}
                <Route path="/forget-password-step-one" element={<StepOne />} />
                <Route path="/forget-password-step-two" element={<StepTwo />} />
                <Route path="/forget-password-step-three" element={<StepThree />} />


                {/* company registration request */}
                <Route path="/company-registration-check-email" element={<CheckEmail />} />
                <Route path="/company-registration-step-one" element={<CRStepOne />} />
                <Route path="/company-registration-step-two" element={<CRStepTwo />} />
                <Route path="/company-registration-step-three" element={<CRStepThree />} />
                <Route path="/company-registration-step-four" element={<CRStepFour />} />
                <Route path="/company-registration-step-five" element={<CRStepFive />} />



            </Routes>
        </div>
    );
};

export default LoginScreen; 